import { render, staticRenderFns } from "./DetailsGoodsDetailedInfo.vue?vue&type=template&id=7fb71c62&scoped=true&"
import script from "./DetailsGoodsDetailedInfo.vue?vue&type=script&lang=js&"
export * from "./DetailsGoodsDetailedInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailsGoodsDetailedInfo.vue?vue&type=style&index=0&id=7fb71c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb71c62",
  null
  
)

export default component.exports